import React from 'react';

const AccountOverview = ({ userData, onEditProfile, onManageSubscription }) => {
  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <div className="bg-dark-600 rounded-2xl p-6 gradient-bg-purple relative overflow-hidden account-glow transform-gpu hover:shadow-lg hover:shadow-accent-purple/20 transition-medium">
        {/* Animated background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 opacity-10 animate-float">
          <i className="fas fa-gem text-accent-purple" style={{ fontSize: '20rem', transform: 'translate(25%, -25%) rotate(15deg)' }}></i>
        </div>
        
        {/* Floating particles */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="particle-1"></div>
          <div className="particle-2"></div>
        </div>
        
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center relative z-10">
          <div className="flex items-center mb-4 lg:mb-0 group">
            <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-accent-purple to-accent-blue flex items-center justify-center mr-5 premium-pulse transform-gpu group-hover:rotate-6 group-hover:scale-105 transition-medium">
              <span className="text-2xl font-bold transform-gpu group-hover:scale-110 transition-medium">
                {userData.name.split(' ').map(n => n[0]).join('')}
              </span>
            </div>
            <div>
              <h2 className="text-3xl font-bold mb-1 group-hover:text-accent-purple transition-medium">
                {userData.name}
              </h2>
              <div className="flex items-center text-sm text-gray-300">
                <span className="mr-3 hover:text-white transition-medium">ID: {userData.id}</span>
                <span className="mr-3">|</span>
                <span className="hover:text-white transition-medium">Joined: {userData.joinDate}</span>
              </div>
              <div className="flex items-center mt-2">
                <div className="relative transform-gpu group-hover:-translate-y-0.5 transition-medium">
                  <span className="px-3 py-1 bg-gradient-to-r from-accent-purple to-accent-blue rounded-lg text-white font-medium mr-2 flex items-center transform-gpu group-hover:scale-105 transition-medium">
                    <i className="fas fa-gem mr-1.5 transform-gpu group-hover:rotate-180 transition-medium"></i> {userData.subscription.type}
                    <span className="ml-1.5 text-xs bg-dark-600 text-white px-1.5 py-0.5 rounded transform-gpu group-hover:scale-110 transition-medium">
                      Level {userData.subscription.level}
                    </span>
                  </span>
                </div>
                <span className="text-xs text-gray-400 group-hover:text-white transition-medium">
                  {userData.subscription.daysLeft} days left
                </span>
              </div>
            </div>
          </div>
          
          <div className="flex gap-3">
            <button 
              onClick={onEditProfile}
              className="bg-dark-500 hover:bg-dark-400 px-4 py-2 rounded-xl text-sm transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 active:shadow-inner flex items-center"
            >
              <i className="fas fa-edit mr-1.5 transform-gpu group-hover:rotate-12 transition-medium"></i> Edit Profile
            </button>
            <button 
              onClick={onManageSubscription}
              className="bg-gradient-to-r from-accent-purple to-accent-pink hover:opacity-90 px-4 py-2 rounded-xl text-sm transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-glow-pink active:translate-y-0 active:shadow-inner flex items-center"
            >
              <i className="fas fa-crown mr-1.5 transform-gpu group-hover:rotate-12 transition-medium"></i> Manage Subscription
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountOverview;